module.exports = __webpack_public_path__ + "media/images/soar/site/faq/cancelar_assinatura.35d6a29eaade-7b1cbd21740e1599e7cba278c89f9db0.png";